import {UI} from "../../../../stem-core/ui/UIBase";

import {styleRule} from "../../../../stem-core/decorators/Style";
import {Messages} from "../../../Messages.js";
import {UserPreferences} from "../../../../client/state/UserPreferencesStore.js";
import {MerchantCard, MerchantCardStyle} from "../../ui/MerchantCard.jsx";
import {BlinkButton} from "../../../../core/ui/Button.jsx";
import {ExternalLink} from "../../ui/ExternalLink";
import {registerStyle} from "../../../../stem-core/ui/style/Theme";
import {MerchantPopup} from "../../ui/MerchantPopup";
import {Money} from "../../../../stem-core/localization/Money.js";
import {userService} from "../../../../client/connection/services/UserService.js";
import {Wallet} from "../../../../client/state/WalletStore.js";
import {iFrameMerchantService} from "../../../services/IframeMerchantService.js";
import {MessageElement} from "../../ui/MessageElement.jsx";
import {apiUpdateUserMerchantPreferences, MerchantUser} from "../../../../client/state/merchant/MerchantUserStore.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {autoredraw} from "../../../../stem-core/decorators/AutoRedraw";


class AutopayCardStyle extends MerchantCardStyle {
    @styleRule
    infoLine = {
        marginBottom: 14,
    };
}


@registerStyle(AutopayCardStyle)
@autoredraw(UserPreferences, MerchantUser)
class AutopayCard extends MerchantCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.manageAutopay,
        };
    }

    isAutopayDefaultDisabled() {
        return !UserPreferences.getPreferences().autoPayEnabled;
    }

    render() {
        const {styleSheet} = this;
        const articlePriceLimit = new Money(
            UserPreferences.getPreferences().articlePriceLimit,
            Wallet.getWallet().getCurrency()
        );
        const disabled = this.isAutopayDefaultDisabled();

        return [
            <MessageElement
                className={styleSheet.infoLine}
                message={disabled ? Messages.disabledAutopayInfo1
                    : Messages.autopayInfo1(iFrameMerchantService.getMerchant().getName(), articlePriceLimit)}/>,
            <div className={styleSheet.infoLine}>
                {disabled ? Messages.disabledAutopayInfo2 : Messages.autopayInfo2}
                <ExternalLink label={Messages.blinkDashboard} href="/"/>.
            </div>,
        ];
    }

    renderPrimaryButton() {
        return <BlinkButton
            label={iFrameUserDataService.isAutoPayEnabled() ? Messages.disableAutopay : Messages.enableAutopay}
            onClick={() => this.toggleAutopay()}
            disabled={this.isAutopayDefaultDisabled()}
        />;
    }

    @wrapInSpinner
    async toggleAutopay() {
        const merchant = iFrameMerchantService.getMerchant();
        await apiUpdateUserMerchantPreferences({
            userId: userService.getUserId(),
            merchantId: merchant.id,
            autoPayEnabled: !iFrameUserDataService.isAutoPayEnabled(),
        });
    }
}

export const Autopay = MerchantPopup(AutopayCard);
